module.exports = __webpack_public_path__ + "img/avatar4.c3655fb0.png";